<template>
  <section class="app-section app-section-light container-fluid pt-5">
    <div class="app-red-hot-offers container p-x-0">
      <div id="app">
        <!-- Search Box -->
        <div class="panel-light panel-cta">
         
                <form onkeypress="return event.keyCode != 13">
                    <div class="row">
                        <div class="col-12 col-sm-10 p-sm-0">
                            <div class="search-holder p-0">
                                <div class="input-group">
                                    <div class="input-group-addon bg-transparent inlinetable search-icon"><i class="material-icons icon-lg">search</i>
                                    </div>
                                    <input type="search" class="form-control form-control-search input-lg"
                                            id="InputSearchResults" ref="InputSearchResults"
                                            
                                            placeholder="Enter words to search for and click Search..."
                                            v-on:keydown.enter="clickSearch()"
                                            v-model="searchValue">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-2 p-sm-0">
                            <button
                            type="button"
                            class="btn text-uppercase w-100 h-100 p-2"
                            style="background-color: #ffa409;"
                            v-on:click="clickSearch()">
                                Search
                            </button>
                        </div>
                    </div>
                 
                </form>

      

            <div class="card-body" id="noSearchResults" v-show="noResults && termsearched !=''">
                <div v-show="!searchError">
                    Your search for &quot;<b>{{termsearched}}</b>&quot; did not find any matches.
                    <br/><br/>
                    <span class="noResultsTitle">Suggestions:</span>
                    <ul class="noResultsList">
                        <li>Make sure all words are spelled correctly.</li>
                        <li>Enter different keywords and click Search.</li>
                        <li>Try more general keywords.</li>
                    </ul>
                    <div id="ViewtrailBookingRef" v-show="looksLikeABookingRef">
                        If you were looking for your ViewTrail Booking, here is a link to ViewTrail:-
                        <br/>
                        <strong>
                            <a :href="VT_LINK" target="_new">My Booking - ViewTrail</a>
                        </strong>
                    </div>
                </div><!-- /!searchError -->
            </div><!-- /#noSearchResults -->
        </div>
    </div>

        <div v-if="getLoadingStatus" class="loading-state">
            <div class="spinner" />
        </div>

        <div id="top-results" v-show="showtopresults">
            <h1 class="section-heading pt-5">Top Results</h1>
            <div class="row gy-4">
                <div class="col-12 col-sm-6 col-md-4 mb-4 mb-md-0" v-for="datum in favResults" :key="datum.index">
                    <div class="card panel-cta bg-light listing-item box-link h-100">
                        <figure class="img-fluid">
                            <a :href="datum.linkIE" target="_new" v-show="siteVar_referer==='IE'" class="bs-override">
                                <img class="h-15rem" data-object-fit="cover" :src="datum.txtBanner" :alt="datum.searchtitle" :title="datum.searchtitle">
                            </a>
                            <a :href="datum.linkUK" target="_new" v-show="siteVar_referer!=='IE'" class="bs-override">
                                <img class="h-15rem" data-object-fit="cover" :src="datum.txtBanner" :alt="datum.searchtitle" :title="datum.searchtitle">
                            </a>
                        </figure>

                        <div class="card-title mx-3">
                            <a :href="datum.linkIE" target="_new" v-show="siteVar_referer==='IE'">
                                <h5 class="h5 panel-title text-strong">{{datum.searchtitle}}</h5>
                            </a>
                            <a :href="datum.linkUK" target="_new" v-show="siteVar_referer!=='IE'">
                                <h5 class="h5 panel-title text-strong">{{datum.searchtitle}}</h5>
                            </a>
                        </div>

                        <div class="card-body">
                            <a :href="datum.linkIE" target="_new" v-show="siteVar_referer==='IE'">
                                <p class="m-b-0" v-html="datum.txtSnippet"></p>
                            </a>
                            <a :href="datum.linkUK" target="_new" v-show="siteVar_referer!=='IE'">
                                <p class="m-b-0" v-html="datum.txtSnippet"></p>
                            </a>
                        </div>

                        <div class="card-footer bg-light border-0">
                            <div >
                                <span class="text-strong text-muted has-icon icon-l">
                                    <i class="material-icons">bookmark</i>
                                    <span>{{datum.type}}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="all-results" v-show="searchCount>0">
            <div class="card border-0 mt-5">
                <div class="card-body" v-show="!noResults">
                    <div id="resultsTitle" class="section-heading text-center m-0" v-show="!noResults">
                        Your Results For: <span class="text-strong text-dark">{{searchValue}}</span>
                    </div>

                    <!-- Pagination -->
                    <div v-show="filteredSearch.length > 0" class="">
                        <div class="row">
                            <div class="col-12">
							<div class="text-center center-block">
                                <p class="text-strong mt-5">Showing {{ startPageNumber }} - {{ endPageNumber }} of
                                    {{ filteredSearch.length }} results
								</p>
                                <p class="text-center">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="itemsPerPage"
                                    v-show="total_rows > 0"
                                    id="pagination"
                                    first-text="First"
                                    prev-text="Prev"
                                    next-text="Next"
                                    last-text="Last"
                                >
                                </b-pagination>
								</p>
								</div>
                            </div><!--col-->
                        </div><!--row-->
                    </div><!--v-show-->
                </div><!--panel-->
            </div><!--#all-results-->

            <div id="search-results" class="row gy-4"><!-- equal-height-panels-->
                <div class="col-12 col-sm-6 col-md-4 mb-4 mb-md-0" v-for="(offer, index) in paginatedSearch" :key="index">
                    <div class="card panel-cta bg-light listing-item box-link h-100">
                        <!-- panel-match-height -->
                        <figure v-bind:class="{'has-object-fit' : offer._source.image !== '/codesource/img/icon-trailfinders-orange.png'}"
                                class="img-fluid">
                            <a :href="offer._source.url" target="_new">
                                <img :src="offer._source.image" class="h-15rem"
                                        v-bind:class="{'p15' : offer._source.image === '/codesource/img/icon-trailfinders-orange.png'}"
                                        :alt="offer._source.title" :title="offer._source.title">
                            </a>
                        </figure>

                        <div class="card-title mx-3">
                            <a :href="offer._source.url" target="_new">
                                <h5 class="h5 panel-title text-strong">{{offer._source.title}}</h5>
                            </a>
                        </div>

                        <div class="card-body">
                            <a :href="offer._source.url" target="_new">
                                <p class="m-b-0" v-bind:html="offer._source.snippet"></p>
                            </a>
                        </div>

                        <div class="card-footer bg-light border-0">
                            <div>
                                <span class="text-strong text-muted has-icon icon-l">
                                    <i class="material-icons">bookmark</i>
                                    <span>{{offer._source.type}}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-center">
                    <!-- Pagination -->
                    <div v-show="filteredSearch.length > 0"
                        class="col-12">
                        <div class="row">
                            <div class="col-12 col-sm-4 col-sm-offset-4 text-center">
                                <p class="text-strong mt-5">Showing {{ startPageNumber }} - {{ endPageNumber }} of
                                    {{ filteredSearch.length }} results</p>

                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="itemsPerPage"
                                    id="pagination"
                                    v-show="total_rows > 0"
                                    first-text="First"
                                    prev-text="Prev"
                                    next-text="Next"
                                    last-text="Last"
                                >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import moment from "moment"
import { SRVgetSearchResults } from '../../services/api'
import { SRVgetAllSearchResults } from '../../services/api'

const headers = {}
headers.Authorization = 'Basic U3RldmVuIENoYXBtYW46S2xvcDA='
headers['content-type'] = 'application/json'
headers['resolveWithFullResponse'] = true

export default {
  data() { 
    return {
      meta: {
        loaded: true
      },
      date: null,
      errorMessage: '',
      loading : true,
      getLoadingStatus: false,
      filteredSearch: [],
      currentPage : 1,				// Pagination
      itemsPerPage : 12,				// Pagination
      total_rows : 0,				// Pagination
      searchResults: [],
      noResults: true,
      searchError: true,
      showtopresults: false,
      resultsHelperNeeded: false,
      looksLikeABookingRef: false,
      topresultmatch: false,
      exresultmatch: false,
      topResultscheck: [],
      favURLs: [],
      selectedURLs: [],
      exURLs: [],
      extopResults: [],
      favCount: 0,
      searchCount: 0,
      // favCheckCount: 0,
      countItemsFrom: 0,
      countItemsTo: 0,
      searchValue: '',
      favResults: [],
      searchDone: false,
      termsearched: '',
      typeClickSelected: '',
      typesTotal: 0,
      productTypes: [],
      pt: [],
      siteVar_referer: 'UK',
      VT_LINK: 'DEFAULT',
    };
  },

  computed: {
    cproductTypes_selected: function() {
         return this.productTypes.filter(pt => (pt.name=='Tours' || pt.name=='Holiday Styles' || pt.name=='Destinations' || pt.name=='Cruises'))
      },
    paginatedSearch: function () {
      return this.filteredSearch.slice(
          (this.currentPage - 1) * this.itemsPerPage,
          this.currentPage * this.itemsPerPage
      )
    },
    startPageNumber: function () {
      return (this.currentPage - 1) * this.itemsPerPage + 1
    },
    endPageNumber: function () {
      let number;
      number = this.currentPage * this.itemsPerPage
      if (number > this.filteredSearch.length) number = this.filteredSearch.length
      return number
    }   
  },

  mounted() {
    
    this.meta.loaded = true;
    this.date = Date.now();
    this.searchValue = '';    
    this.siteVar_referer = window.siteVar.referer;
    this.VT_LINK = process.env.VUE_APP_VIEWTRAIL;

//// ***** process.env.VUE_BASE_URL


    if(this.$route.params.searchValue) {
        this.searchValue = this.$route.params.searchValue;
    }

    this.focusInput();
  },

filters: {
    typefilter: function () {
        return function (items) {
            var filtered = [];
            var applyFilter = false;
            // Figure out if the user has switched any Filters on or not.

            this.productTypes.forEach(function (type) {
                if (type.selected) {
                    applyFilter = true;
                }
            });

            if (applyFilter == true) {
                // If the user has switched any Filters on then only pass back those that match the filter.

                items.forEach(function (item) {
                    var tmp = item._source.type;
                    if (this.productTypes[tmp].selected == true) {
                        filtered.push(item);
                        this.typeClickSelected = item._source.type;
                    } // else if (types.pack_brochured == true && item._source.type == 'Brochure Package') {
                });
            } else {
                // If the user hasn't switched on any Filters, then pass all values back.
                this.typeClickSelected = '';
                items.forEach(function (item) {
                    var tmp = item._source.type;
                    if ((tmp == "Holiday Styles") || (tmp == "Tours") || (tmp == "Destinations") || (tmp == "Cruises")) {
                        filtered.push(item)
                    }
                })

                //once we have an array of filtered items we need to sort them so holiday styles and tours always appear first
                filtered = this.sortResults(filtered);
            }

            this.searchCount = filtered.length;
            this.totalPages = (((this.searchCount / this.itemsPerPage) + 1).toFixed(0));
            var checkTotPages = (((this.searchCount / this.itemsPerPage)).toFixed(0));
            var checkTotSearch = checkTotPages * this.itemsPerPage;

            if(checkTotSearch >= this.searchCount) {
                //don't need the additional page, so reset
                this.totalPages = checkTotPages;
            }

        // Need to add / remove active class from result pages
            for (var i = 1; i <= this.totalPages; i++) {
                var theDiv = '#resultPage' + i.toString();
                var theDivB = '#resultPageB' + i.toString();

                if (i === this.currentPage) {
                    this.$refs[theDiv].classList.add('active');
                    this.$refs[theDivB].classList.add('active');
  //                  angular.element(theDiv).addClass("active");
  //                  angular.element(theDivB).addClass("active");
                } else {
                    this.$refs[theDiv].classList.remove('active');
                    this.$refs[theDivB].classList.remove('active');
//                    angular.element(theDiv).removeClass("active");
//                    angular.element(theDivB).removeClass("active");
                }
            }

        var subtractTot = this.itemsPerPage - 1;
        this.countItemsFrom = (this.currentPage * this.itemsPerPage) - subtractTot;

        if (this.searchCount < this.itemsPerPage) {
            this.countItemsTo = this.searchCount;
        } else {
            var checkCountTo = this.currentPage * this.itemsPerPage;

            if(checkCountTo > this.searchCount) {
                this.countItemsTo = this.searchCount;
            } else {
                this.countItemsTo = checkCountTo;
            }
        }

        return filtered.slice(((this.currentPage - 1) * this.itemsPerPage), ((this.currentPage) * this.itemsPerPage));
    }
}
},

  methods: {
    focusInput(){
        this.$refs.InputSearchResults.focus();
        if(this.searchValue) {
             this.clickSearch();
        }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    sortResults(obj) {
        var result = [];
        // Need to sort search results by (1) Holiday Styles then (2) Tours
        // Create three arrays, then join them
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];

        obj.forEach(function (result) {
            var tmp = result._source.type;
            if (tmp == "Holiday Styles") {
                arr1.push(result);
            } else if (tmp == "Tours") {
                arr2.push(result);
            } else {
                arr3.push(result);
            }
        });

        result = arr1.concat(arr2);
        result = result.concat(arr3);

        return result;
    },

    difference(a1, a2) {
        var result = [];
        for (var i = 0; i < a1.length; i++) {
            if (a2.indexOf(a1[i]) === -1) {
                result.push(a1[i]);
            }
        }
        return result;
    },

    removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    },

    clearSearch() {
        // hide the everything as these are for the search term in the query string. TODO: switch off when looked up from submit button.
        this.searchResults = [];   //MRB 20210507
        this.filteredSearch = [];
        this.favURLs = [];
        this.selectedURLs = [];
        this.exURLs = [];
        this.extopResults = [];
        this.showtopresults = false;
        this.filtered = false;
        this.productTypes = {};
        this.noResults = true;
        this.resultsHelperNeeded = true;
        this.searchCount = 0;
        this.currentPage = 1;
    },		// end of clearSearch() function

    filterToggle(filter) {
        this.filters[ filter ] = !this.filters[ filter ];
        if( this.filters[ filter ] ) { this.currentPage = 1 }
        this.typeSelected(filter);
    },

    typeSelected( typ ){ // toggle function called from the toggle of the checkboxs in left-hand menu of Filters.
        this.productTypes[ typ ].selected = this.productTypes[ typ ].selected == true ? false : true;
        this.filtered = false;
        this.productTypes.forEach(function (type) {
            this.filtered = this.filtered || type.selected;
        })
    },

    resetTheCount() {
        this.productTypes.forEach(function (type) {
            type.count = 0;
        })
    },

    clearAllFilters() {
        this.productTypes.forEach(function (type) {
            type.selected = false;
        })
        this.filtered = false;
    },

    async getSearchResults (searchterm) {
        this.searchDone = true
        let checkTotPages = 0
        const checkTotSearch = 0
        this.searchError = false
        const resp = await SRVgetSearchResults(searchterm)
        ///handles the extra search results (not top)
        
        if(!resp || !resp.hits) {
            this.searchError = true
        } else {
            if (!resp.hits.hits.length) {
                this.searchError = false
                this.noResults = true
                this.loading = false
            }
      
            if (resp.hits.hits && resp.hits.hits.length > 0) {
                // Remove flights from search results
                const updatedResults = resp.hits.hits.filter(item => item._source.type !== 'Flights' )
                this.filteredSearch = updatedResults
                this.searchResults = updatedResults //  MRB 20210507
                this.searchCount = updatedResults.length
                this.searchCountTotal = updatedResults.length
                this.checkCount = parseInt(this.searchCount)
            }

            if (this.searchCount > 0) {
                this.total_rows = this.filteredSearch.length
                this.totalPages = ((this.searchCount / this.itemsPerPage) + 1).toFixed(0)
                checkTotPages = (((this.searchCount / this.itemsPerPage)).toFixed(0))
                this.totalPages = checkTotPages * this.itemsPerPage
            } else {
                this.totalPages = 1
            }

            if (checkTotSearch > this.searchCount) {
                // don't need the additional page, so reset
                this.totalPages = checkTotPages
            }
        }

        if (this.searchCount >= 1) {
            this.noResults = false
            let typeName = ''
            // var typeCount = -1;
            let checkURL = ''
            let typeTitle = ''

            // this.searchResults.forEach(function (item) { Arrow notation to keep current scope.
            this.filteredSearch.forEach((item) => {
                typeName = item._source.type
                typeTitle = item._source.title

                // no speific tour type cruises lited in searches, therefore have to derive from title
                if (typeTitle.toLowerCase().indexOf('cruise') > -1) {
                    if (typeTitle.toLowerCase().indexOf('cruise america') > -1) {
                    // do nothing, it's motorhomes
                    } else if (typeTitle.toLowerCase().indexOf('cruise canada') > -1) {
                    // do nothing, it's motorhomes
                    } else {
                    item._source.type = 'Cruises'
                    typeName = 'Cruises'
                    }
                }

                if ((typeName === 'Holiday Styles') || (typeName === 'Tours') || (typeName === 'Destinations') || (typeName === 'Cruises')) {
                    this.typesTotal = this.typesTotal + 1
                }

                if (this.productTypes[typeName]) {
                    // if this Type already exists, just increment the count
                    this.productTypes[typeName].count++
                } else {
                    // if this Type doesn't already exist, then set it up.
                    // typeCount++;
                    this.productTypes[typeName] = {}
                    this.productTypes[typeName].count = 1
                    this.productTypes[typeName].name = typeName
                    this.productTypes[typeName].selected = false

                    if ((typeName === 'Flights') || (typeName === 'Hotels') || (typeName === 'Tours') || (typeName === 'Destinations')) {
                    this.resultsHelperNeeded = true
                    }
                }

                if (this.favCount >= 1) {
                checkURL = item._source.url
                if (this.siteVar_referer === 'IE') {
                checkURL = checkURL.substring(checkURL.indexOf('.ie') + 3)
                } else {
                checkURL = checkURL.substring(checkURL.indexOf('.com') + 4)
                }
                }
            })

            // Once we have all product types, need to sort -
            if (this.favCount >= 1) {
            // if (this.favCount > this.favCheckCount) {
                this.favsEx = this.difference(this.favURLs, this.selectedURLs)
                this.showtopresults = true
                this.noResults = false
                this.exresultmatch = true
                const uniqueArray = this.removeDuplicates(this.favResults, 'linkUK')
                this.favResults = uniqueArray
              
                // this.favResults.forEach(function (item) {   Arrow Notation for current scope
                this.favResults.forEach((item) => {
                    for (let i = 0; i < this.favsEx.length; i++) {
                        if (this.siteVar_referer === 'IE') {
                            if (this.favsEx[i] === item.linkIE) {
                            this.extopResults.push(item)
                            this.checkCount = this.checkCount + 1
                            break
                            }
                        } else {
                            if (this.favsEx[i] === item.linkUK) {
                            this.extopResults.push(item)
                            this.checkCount = this.checkCount + 1
                            break
                            }
                        }
                    }
                })

                this.favCount = this.extopResults.length
                this.checkCount = this.checkCount.toString()
                this.searchCount = this.checkCount
                this.countItemsFrom = 1

                if (this.searchCount < this.itemsPerPage) {
                    this.countItemsTo = this.searchCount
                } else {
                    this.countItemsTo = this.itemsPerPage
                }
            } else {
                // No favourites, make sure it's all hidden
                this.showtopresults = false
            }
        } else if (this.favCount >= 1) {
            // No matches for the search, but favourite(s) listed, add them to extopResults
            this.showtopresults = true
            this.noResults = false
            this.exresultmatch = true

            this.favResults.forEach((item) => {
                this.extopResults.push(item)
            })

            this.favCount = this.extopResults.length
        } else {
            this.showtopresults = false
            // const regex = new RegExp('^[a-zA-Z0-9]{6}$')

            const words = searchterm.split(/[+ ]/)
            this.looksLikeABookingRef = false

            for (let i = 0; i < words.length; i++) {
            // if (words[i].match(regex)) {
                if (/^[a-zA-Z0-9]{6}$/.test(words[i])) {
                    this.looksLikeABookingRef = true
                    break
                }
            }
            this.noResults = false
        }
        this.loading = false
    },

    clickSearch() {
        if (this.searchValue == "") {
            this.loading = false;
            return;
        } else {
            // var url = "../search/" + this.searchValue;
            // window.location.href = url;
        }

        var criteria = this.searchValue;
        criteria = criteria.replace(/[()\s,&#)]/g, '+');		// regex global replace of brackets, spaces, commas, ampersands with plus signs in search criteria.
        criteria = criteria.toLowerCase();
        this.doSearch(criteria);
    },

   async doSearch(searchVal) {
        this.searchError = false;
        this.termsearched = '';
        this.noResults = false
        this.getLoadingStatus = true;
        if ((!searchVal) || (searchVal === '')) {
            this.getLoadingStatus = false
            return;
        }

        this.searchResults = [];   // MRB 20210507
        this.filteredSearch = [];
        this.looksLikeABookingRef = false;			// does the query look like a Viewtrail Booking Ref?
        this.resultsHelperNeeded = false;
        this.topresultmatch = false;
        this.exresultmatch = false;
        this.topResultscheck = []; // favourites go here if there are any
        this.favURLs = []; // favourites go here if there are any
        this.selectedURLs = []; // favourites go here if there are any
        this.exURLs = []; // favourites go here if there are any
        this.extopResults = []; // favourites go here if there are any
        this.favCount = 0;
        // this.favCheckCount = 0;
        this.countItemsFrom = 0;
        this.countItemsTo = 0;
        this.termsearched = searchVal;
        var searchterm = searchVal.toLowerCase();
        const data = await SRVgetAllSearchResults(searchterm)
        // Check to see if there are any listed favourites
        this.favResults = data;
        this.favCount = data.length;
        var tmpArray = [];
        var tmpUNIDs = '';

//  Reduce favresults duplicates based on based on @unid and UK or IE  
        for (var i = 0; i < this.favResults.length; i++){
            if(!tmpUNIDs.includes(this.favResults[i]['@unid'])) {
                if(this.siteVar_referer==='IE') {
                    if(this.favResults[i]['linkIE']!=='') {
                        tmpUNIDs = tmpUNIDs + this.favResults[i]['@unid'] + ',';
                        tmpArray.push(this.favResults[i]);
                    }
                } else {
                    if(this.favResults[i]['linkUK']!=='') {
                        tmpUNIDs = tmpUNIDs + this.favResults[i]['@unid'] + ',';
                        tmpArray.push(this.favResults[i]);
                    }
                }
            }
        }
        this.favResults = [ ...new Set(tmpArray) ];
        this.favCount = this.favResults.length;
        tmpArray = [];
        if (this.favCount >= 1) {
            if (this.siteVar_referer === 'IE') {
                this.favResults.forEach(function (Result) {
                    tmpArray.push(Result.linkIE);
                })
            } else {
                this.favResults.forEach(function (Result) {
                    tmpArray.push(Result.linkUK);
                })
            }

            this.favURLs = [ ...new Set(tmpArray) ];
        }

        this.searchAll = this.getSearchResults(searchterm);
        this.getLoadingStatus = false
    },		// end of doSearch() function.
  }
};
</script>

<style>
#pagination .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #ffa409;
    border-color: #ffa409;
    color: black !important;
}
.page-link {
    color: black !important;
}
</style>

<style lang="scss">
    .loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    }
    .spinner {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 10px solid #ddd;
    border-top-color: orange;
    animation: loading 1s linear infinite;
    }
    @keyframes loading {
    to {
        transform: rotate(360deg);
    }
    }
</style>
